import React, { Component } from 'react';
import '../styles/home.css'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      <div className="home overflow-auto">
        <div className='landingText'>
          <p className="text-center"><h3>Producing leaders of change through education and encouragement</h3></p><br/>
          <p className=" title text-center"><h1>Leaping forward to revolutionize the media industry</h1></p>
        </div>
        <div className='row justify-content-center'>
          <div className="homeCard col-md-3 col-sm-3 border border-success" data-aos="fade-right">
            <div className='cardTxt'>
              <h4>1. Quality</h4>
              <div>
                <p className="card-text">We want to be the best we can be, and we strive to constantly improve the quality of our service and products.</p>
              </div>
            </div>
        </div>
        <div className="homeCard col-md-3 col-sm-3 border border-success" data-aos="fade-right">
          <div className='cardTxt'>
            
            <h4>2. Reliable</h4>
            <div>
              <p className="card-text">We pride ourselves on our dependability and it’s one of the first words that satisfied clients have.</p>
            </div>
          </div>
        </div>
        <div className="homeCard col-md-3 col-sm-3 border border-success" data-aos="fade-right">
          <div className='cardTxt'>
            
            <h4>3. Passion</h4>
            <div>
                <p className="card-text">We have turned a part-time hobby into a full-time business but our passion for photography remains unabated.</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    );
  }
}
